// core
import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { AppointmentResolver } from '@open-portal-app/core/resolvers/appointments.resolver';
import { UserDetailsResolver } from '@open-portal-app/core/resolvers/user-details.resolver';

import { AppointmentFlowComponent } from '@open-portal-app/appointments/appointment-flow/appointment-flow.component';

const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    component: AppointmentFlowComponent,
    resolve: {
      availableTimeslots: AppointmentResolver,
      userDetails: UserDetailsResolver
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AppointmentsRoutingModule { }
